export default function getResource(label, vars = []) {
    const resources = {
        checkoutInitializationFailed: 'Unable to initialize PayPal checkout. Please try again or use a different payment method.',
        orderPlacementFailed: 'Unable to complete your order. Please try again or use a different payment method.',
        checkoutErrorTitle: 'PayPal Checkout Error',
        orderPlacementErrorTitle: 'Order Placement Error',
        okButton: 'OK'
    };

    return resources[label];
}
